module.exports = __webpack_public_path__ + "img/img-store-step3.6c4dd319.svg";